import { ReviewSecondaryRating } from "@omni/types/api/reviews/bff/shared/reviewSecondayRating.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

type SecondaryRatingProps = {
    secondaryRating: ReviewSecondaryRating;
};

export const SecondaryRating = ({ secondaryRating }: SecondaryRatingProps) => {
    const { t } = useGranite();

    const displayQualityAverage = formatNumber(
        secondaryRating.quality.value,
        Config.getLocale(),
        {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }
    );
    const displayValueAverage = formatNumber(
        secondaryRating.value.value,
        Config.getLocale(),
        {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }
    );

    return (
        <div className={cn("tw:sm:max-w-75")}>
            <div className={cn("tw:not-first:mt-4")}>
                <p className={cn("tw:mb-1")}>
                    {t("product.reviews.filters.secondaryRating.quality")}
                </p>
                <p className={cn("tw:flex tw:items-center tw:gap-4")}>
                    <span className={cn("tw:min-w-fit")}>
                        {displayQualityAverage}
                    </span>
                    <progress
                        className={cn(
                            "tw:h-6 tw:rounded-xl tw:overflow-hidden tw:w-full",
                            "tw:bg-grey tw:border tw:border-grey-input tw:[&::-webkit-progress-bar]:bg-grey tw:[&::-webkit-progress-value]:bg-primary tw:[&::-moz-progress-bar]:bg-primary"
                        )}
                        max={secondaryRating.quality.range}
                        value={secondaryRating.quality.value}
                    />
                </p>
            </div>
            <div className={cn("tw:not-first:mt-4")}>
                <p className={cn("tw:mb-1")}>
                    {t("product.reviews.filters.secondaryRating.value")}
                </p>
                <p className={cn("tw:flex tw:items-center tw:gap-4")}>
                    <span className={cn("tw:min-w-fit")}>
                        {displayValueAverage}
                    </span>
                    <progress
                        className={cn(
                            "tw:h-6 tw:rounded-xl tw:overflow-hidden tw:w-full",
                            "tw:bg-grey tw:border tw:border-grey-input tw:[&::-webkit-progress-bar]:bg-grey tw:[&::-webkit-progress-value]:bg-primary tw:[&::-moz-progress-bar]:bg-primary"
                        )}
                        max={secondaryRating.value.range}
                        value={secondaryRating.value.value}
                    />
                </p>
            </div>
        </div>
    );
};
